import { Component, HostListener, inject, Input, OnChanges, OnDestroy, SimpleChanges, } from '@angular/core';
import { UploadComponent } from '@shared-features/input/upload-2/upload.component';
import { WorkflowOverviewService } from '../../data-access/workflow-overview.service';
import { ProcessService } from '@shared-api/process/process.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { ProcessResponse } from '@shared-interfaces/shared-process';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { KeyValuePipe } from '@angular/common';
import { ContractResultsDownload, DoraResponse } from '@shared-interfaces/shared-workflow';

@Component({
    selector: 'workflow-view',
    standalone: true,
    imports: [UploadComponent, MatButtonModule, MatExpansionModule, KeyValuePipe],
    templateUrl: './workflow-view.component.html',
    styleUrls: ['./workflow-view.component.scss'],
})
export class WorkflowViewComponent implements OnChanges, OnDestroy {
    workflowService = inject(WorkflowOverviewService);
    private processService = inject(ProcessService);
    @Input() workflowId: string | undefined = undefined;

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.workflowService.workflowId()) {
            this.workflowService.updateWorkflowData$.next();
        }
        this.workflowService.getWorkflowData$.next(this.workflowId);
    }

    constructor(private snackBar: MatSnackBar) {
        this.processService.processResults$
            .pipe(
                takeUntilDestroyed(),
                filter((process) => {
                    return (
                        ['completed', 'failed'].includes(process.status) &&
                        process.details.frontendIdentifier ===
                        this.workflowService.workflowId()
                    );
                })
            )
            .subscribe((processResults: ProcessResponse) => {
                this.processResultActions(processResults);
            });
    }

    processResultActions(process: ProcessResponse): void {
        switch (process.name) {
            case '/file/upload':
                this.workflowService.updateFile$.next(process);
                break;
            case '/genai':
                this.workflowService.updateContractAnalysis$.next(process);
                break;
            default:
                break;
        }
    }

    private isContractResults(data: any): data is ContractResultsDownload {
        return (
            typeof data === 'object' &&
            Object.values(data).every((value) => Array.isArray(value))
        );
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event) {
        this.workflowService.updateWorkflowData$.next();
    }

    public ngOnDestroy(): void {
        this.workflowService.updateWorkflowData$.next();
    }
}
